import { createSlice } from '@reduxjs/toolkit';
import {
  findSelectToppingsCategoryItemExport
} from './api';
import { initialState } from './api/interface';

const selectToppingCategoryItemExportSlice = createSlice({
  name: 'selectToppingCategoryItemExport',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectToppingsCategoryItemExport.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectToppingsCategoryItemExport.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findSelectToppingsCategoryItemExport.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { reset } =
  selectToppingCategoryItemExportSlice.actions;
export default selectToppingCategoryItemExportSlice.reducer;
